import {connect} from "react-redux";
import React, {useCallback, useEffect, useMemo, useRef, useState} from "react";
import {CAlert, CButton, CCol, CForm, CFormSelect, CInputGroup, CInputGroupText, CRow} from "@coreui/react";

import StoreListWhere from "../../../where/StoreListWhere";

import {DatePicker} from "antd";
import dayjs from "dayjs";
import "dayjs/locale/ko";
import locale from "antd/es/date-picker/locale/ko_KR";
import {AgGridColumn, AgGridReact} from "ag-grid-react";
import "ag-grid-enterprise";

import * as o2Api from "../../../../../api/api";
import "src/scss/grid-styles.scss";
import StoreCornerListWhere from "../../../where/StoreCornerListWhere";
import {getCornerSale, getCornerSaleDaily} from "../../../../../api/api";
import {Loading} from "../../../../../components/common";
import {currencyFormatter} from "../../../../../config/formatter";
import * as formatter from "../../../../../config/formatter";

const {RangePicker} = DatePicker;
const HourlyMonthlySaleReport = (props) => {
	const gridRef = useRef();
	const containerStyle = useMemo(() => ({width: "100%", height: "100%"}), []);
	const [headerData, setHeaderData] = useState([]);
	const [gridData, setGridData] = useState([]);
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState({
		visible: false,
		message: ""
	});
	const [searchForm, setSearchForm] = useState({
		cmpCd: "", brandCd: "", storeCd: "", cornerCd: "", saleHour: "",
		fromSaleDt: dayjs(), toSaleDt: dayjs()
	});

	const defaultColDef = {
		flex: 1,
		resizable: true,
		sortable: true,
		filter: false,
		autoHeaderHeight: true
	};

	const timeValueGetter = (params) => {
		return params.value + "시";
	}

	const [hourlyHeaderDef] = useState([
		{
			field: "brandCd", rowGroup: true, hide: true, valueFormatter: () => {
				return "전체"
			}
		},
		{
			field: "saleQty",
			headerName: "영수건수",
			valueFormatter: currencyFormatter,
			cellClass: "number-cell",
			aggFunc: 'sum'
		},
		{
			field: "payAmt",
			headerName: "실매출액",
			valueFormatter: currencyFormatter,
			cellClass: "number-cell",
			aggFunc: 'sum',
			cellStyle: {color: "blue", cursor: "pointer"}
		},
	]);

	const [columnDefs] = useState([
		{field: "cmpCd", rowGroup: true, hide: true, valueFormatter: () => { return "전체" }},
		{field: "saleDt", rowGroup: true, hide: true},
		{field: "brandNm", rowGroup: true, hide: true},
		{field: "storeNm", rowGroup: true, hide: true},
		{
			field: "saleDt",
			headerName: "요일",
			valueFormatter: (e) => formatter.weekendFormatter(e, "YYYYMMDD"),
			minWidth: 60,
			aggFunc: (e) => {
			    let result = "";
			    if (e.rowNode.level > 0) {
                    result = e.values.length > 0 ? e.values[0] : "";
                }
                return result;
			}
		},
		{
			field: "saleAmt",
			headerName: "총매출액",
			valueFormatter: currencyFormatter,
			cellClass: "number-cell",
			aggFunc: "sum"
		},
		{
			field: "dcAmt",
			headerName: "총할인",
			valueFormatter: currencyFormatter,
			cellClass: "number-cell",
			aggFunc: "sum"
		},
		{
			field: "payAmt",
			headerName: "실매출액",
			valueFormatter: currencyFormatter,
			cellClass: "number-cell",
			aggFunc: "sum"
		},
		{
			field: "saleQty",
			headerName: "판매수량",
			valueFormatter: currencyFormatter,
			cellClass: "number-cell",
			aggFunc: "sum"
		},
		{
			field: "bagPrice",
			headerName: "봉투",
			valueFormatter: currencyFormatter,
			cellClass: "number-cell",
			aggFunc: "sum"
		},
	]);

	const autoHourlyGroupColumnDef = useMemo(() => {
		return {
			field: "saleHour",
			headerName: "시간대",
			valueFormatter: (e) => timeValueGetter(e),
			minWidth: 80
		}
	}, [])

	const autoGroupColumnDef = useMemo(() => {
		return {
			field: "versionNm",
			headerName: "판매일자",
			minWidth: 200
		}
	}, [])

	useEffect(() => {

	}, []);

	const onGridReady = useCallback((params) => {
		gridRef.current.api.sizeColumnsToFit();
	}, [])

	const handleSelect = (code, value) => {
		if (value === "C") {
			setSearchForm((state) => ({
				...state,
				cmpCd: code
			}));
		} else if (value === "B") {
			setSearchForm((state) => ({
				...state,
				brandCd: code
			}));
		} else if (value === "S") {
			setSearchForm((state) => ({
				...state,
				storeCd: code
			}));
		} else if (value === "O") {
			setSearchForm((state) => ({
				...state,
				cornerCd: code
			}));
		}
	};

	const search = () => {
		setError({
			visible: false,
			message: ""
		});

		const {cmpCd, brandCd, storeCd, cornerCd} = searchForm;
		if (brandCd.length === 0) {
			setError({
				visible: true,
				message: "조회시 휴게소는 반드시 선택하셔야 합니다."
			});
			return;
		}

		const params = {
			cmpCd: cmpCd,
			brandCd: brandCd,
			storeCd: storeCd,
			cornerCd: cornerCd,
			saleHour: searchForm.saleHour,
			fromSaleDt: searchForm.fromSaleDt.format("YYYYMM01"),
			toSaleDt: searchForm.toSaleDt.format("YYYYMM31")
		};

		setLoading(true);
		o2Api.getCornerSaleHourly(params).then((result) => {
			const {responseBody, responseCode, responseMessage} = result.data;
			console.log("### response :: ", responseBody);
			if (responseCode === "200") {
				setLoading(false);
				setHeaderData(responseBody);
			}
		})
			.catch((e) => {
				alert("데이터 조회에 실패했습니다.\n" + e.message);
			})
			.finally(() => {
				setLoading(false);
			});
	};

	const detail = (e) => {
		const {cmpCd, brandCd, storeCd, cornerCd} = searchForm;
		const params = {
			cmpCd: cmpCd,
			brandCd: brandCd,
			storeCd: storeCd,
			cornerCd: cornerCd,
			saleHour: e.data.saleHour,
			fromSaleDt: searchForm.fromSaleDt.format("YYYYMM"),
			toSaleDt: searchForm.toSaleDt.format("YYYYMM")
		};

		setLoading(true);
		o2Api.getCornerSaleHourlyDetail(params).then((result) => {
			const {responseBody, responseCode, responseMessage} = result.data;
			console.log("### response :: ", responseBody);
			if (responseCode === "200") {
				setLoading(false);
				setGridData(responseBody);
			}
		});
	}

	const onCellClicked = (e) => {
		switch (e.colDef.field) {
			case "payAmt":
				if (e.rowIndex != 0) {
					detail(e);
				}
				break;
		}
	};

	return (
		<>
			<div style={containerStyle}>
				{error.visible ? <CAlert color="danger" dismissible={true}>{error.message}</CAlert> : null}
				{loading ? <Loading/> : null}
				<CForm className={"row row-cols-lg-auto g-1 align-items-center"}>
					<StoreCornerListWhere type={"S"} account={props.account} selected={searchForm} onSelect={(c, v) => handleSelect(c, v)}/>
					<CCol xs={12}>
						<CInputGroup size="sm">
							<CInputGroupText style={{width: 100}}>조회일자</CInputGroupText>
							<CInputGroupText style={{background: "white", height: 32}}>
								<RangePicker bordered={false}
											 separator={"~"}
											 picker={"month"}
											 placeholder={""}
											 locale={locale}
											 value={[searchForm.fromSaleDt, searchForm.toSaleDt]}
											 onChange={(dayjs, dateString) => {
												 setSearchForm((state) => ({
													 ...state, fromSaleDt: dayjs[0], toSaleDt: dayjs[1]
												 }));
											 }}/>
							</CInputGroupText>
						</CInputGroup>
					</CCol>
					<CCol xs={12}>
						<CButton size={"sm"} onClick={search}>조회</CButton>
					</CCol>
				</CForm>

				<div style={{height: 10}}/>
				<CRow>
					<CCol xs={4}>
						<div style={{borderRadius: 5, padding: 10, marginBottom: 10, background: "#87CEFA"}}>
							시간대별
						</div>
						<div className="ag-theme-alpine" style={{width: "100%", height: 450, marginTop: 10}}>
							<AgGridReact
								ref={gridRef}
								onGridReady={onGridReady}
								headerHeight={30}
								rowHeight={30}
								rowData={headerData}
                                rowSelection={"single"}
								animateRows={true}
								autoGroupColumnDef={autoHourlyGroupColumnDef}
								groupDefaultExpanded={1}
								suppressAggFuncInHeader={true}
								onCellClicked={onCellClicked}
								defaultColDef={defaultColDef}
								columnDefs={hourlyHeaderDef}>
							</AgGridReact>
						</div>
					</CCol>
					<CCol>
						<div style={{borderRadius: 5, padding: 10, marginBottom: 10, background: "#87CEFA"}}>
							매출상세
						</div>
						<div className="ag-theme-alpine" style={{width: "100%", height: 450, marginTop: 10}}>
							<AgGridReact
								ref={gridRef}
								onGridReady={onGridReady}
								headerHeight={30}
								rowHeight={30}
								rowData={gridData}
                                enableRangeSelection={true}
								animateRows={true}
								groupDefaultExpanded={1}
								suppressAggFuncInHeader={true}
								autoGroupColumnDef={autoGroupColumnDef}
								defaultColDef={defaultColDef}
								columnDefs={columnDefs}>
							</AgGridReact>
						</div>
					</CCol>
				</CRow>
			</div>
		</>
	);
};

const mapStateToProps = (state) => {
	const {account, store, selected} = state;
	return {
		account, store, selected
	};
};

export default connect(mapStateToProps, null)(HourlyMonthlySaleReport);
